export default __webpack_public_path__ + "static/media/timericon@2x.c62ff03d.png";